<template>
    <div id="odiv">
        <p class="p1">查看详情</p>
        <!--<p>-->
        <!--<el-row :gutter="20">-->
        <!--<el-col :span="4"><div class="grid-content bg-purple">入库单号：211312</div></el-col>-->
        <!--<el-col :span="4"><div class="grid-content bg-purple">发货日期：2012-12-12</div></el-col>-->
        <!--<el-col :span="4"><div class="grid-content bg-purple">入库日期：2012-12-12</div></el-col>-->
        <!--<el-col :span="4"><div class="grid-content bg-purple">入库方式：采购入库</div></el-col>-->
        <!--<el-col :span="4"><div class="grid-content bg-purple">供应商：华东药厂</div></el-col>-->
        <!--<el-col :span="4"><div class="grid-content bg-purple">制单时间：2012-12-12</div></el-col>-->
        <!--<el-col :span="4"><div class="grid-content bg-purple">制单人：李彦宏</div></el-col>-->
        <!--<el-col :span="4"><div class="grid-content bg-purple">审核日期：2012-12-12</div></el-col>-->
        <!--<el-col :span="4"><div class="grid-content bg-purple">审核人员：雷军</div></el-col>-->
        <!--<el-col :span="4"><div class="grid-content bg-purple">备注：</div></el-col>-->
        <!--</el-row>-->
        <!--</p>-->
        <el-table :data="tableData" stripe style="width: 98%" row-key="rowkey" border
                  :header-cell-style="tableHeaderColor">
            <el-table-column type="index" label="序号" width="auto"></el-table-column>
            <el-table-column prop="medicineName" label="药品名称" width="auto"></el-table-column>

            <el-table-column prop="saleNunmber" label="数量">

            </el-table-column>
            <el-table-column prop="medicineUnit" label="单位" width="auto"></el-table-column>
        </el-table>
        <el-button :plain="true" type="info" @click="back" style="margin: 20px 10px">返回</el-button>
    </div>
</template>
<style type="text/css" scoped>
    .el-button--primary {
        color: #fff;
        background-color:  rgb(60, 110, 169);
        border-color: rgb(60, 110, 169);
    }
    .el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
        color: #fff;
        background-color: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
    }
    .el-button--primary:focus, .el-button--primary:hover {
        background: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
        color: #fff;
    }
    #odiv {
        width: 98%;
        margin-left: 18px;
        padding-bottom: 30px;
        background-color: white;
    }

    p {
        width: 100%;
        color: rgba(0, 0, 0, 0.56);
        line-height: 55px;
        font-family: 微软雅黑;
        /*border-bottom: 1px solid #e7e7e7;*/
    }

    .p1 {
        /*background: #eee;*/
        height: 50px;
        line-height: 50px;
        font-size: 20px;
        padding-left: 5px;
        width: 100%;
        color: #95b2d4;
    }

    .margintop2 div {
        margin-top: 8px;
    }

    .p3 {
        height: 65px;
        border-bottom: 1px solid #e7e7e7;
    }

    .p3 span {
        margin-left: 1000px;
    }

    .margintop2 {
        margin-left: 150px;
    }


</style>
<script >

  export default {
    data() {
      return {
        pickerOptions0: {},
        active: true,
        num: 554,
        tableData: [],
        saleOrderNo: ''
      }
    },
    mounted: function () {
      this.saleOrderNo = this.$route.query.saleOrderNo;
      this.getinfo();
    },
    methods: {
      getinfo: function () {
        this.$axios({
          url: '/api/medicine/sale/' + this.saleOrderNo,
          method: 'GET'
        }).then(res => {
          this.tableData = res.data.data.saleDetails
        }).catch(err => {
          console.log(err.data)
        })
      },
      tableHeaderColor({row, column, rowIndex, columnIndex}) {
        if (rowIndex === 0) {
          return "background-color:#f2f2f2;color: #a4a7af;";        }
      },
      back: function () {
        this.$router.push({path: "./outHouse"});
      }
    },


  }
</script>



// WEBPACK FOOTER //
// checkout.vue?041501ea